import cv from '../assets/pdf/CV.pdf'
import myimg from '../assets/png/myimg5.jpeg'

export const headerData = {
    name: 'Deepankar Sharma',
    title: "Android Developer",
    desciption:"Entry-level developer with proven problem solving, research and analytical skills seeking a programmer position to grow career as an IT professional.",
    image: {myimg},
    resumePdf: {cv}
}
